module.exports = __webpack_public_path__ + "media/vo-03-02.e7d7641d.mp3";